module.exports = "<h3 ng-bind=\"'EMPTY_PAGE' | translate\"></h3>";


//////////////////
// WEBPACK FOOTER
// ./sources/utility/empty/empty.html
// module id = 867
// module chunks = 0